import { useTranslation } from "react-i18next";

import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";

import { Modal } from "@/components";
import { Icon } from "@/components/Icon/Icon";

interface UnsavedChangesModalProps {
	isOpen: boolean;
	/** Keep the drawer open and go back to editing. */
	onKeepEditing: () => void;
	/** Throw the edits away and close. */
	onDiscard: () => void;
	/** Submit the form, then close. */
	onSave: () => void;
}

/** Closing a drawer with a half-typed title used to lose it silently. */
export default function UnsavedChangesModal({
	isOpen,
	onKeepEditing,
	onDiscard,
	onSave,
}: UnsavedChangesModalProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`to-do.unsaved.${key}`);

	return (
		<Modal
			aboveHeader={<Icon className="w-4 h-4" icon={faTriangleExclamation} />}
			cancelButtonText={ts("keepEditing")}
			dialogContentClassName="!p-0"
			handleClose={onKeepEditing}
			handleSave={onSave}
			handleSecondSave={onDiscard}
			isOpened={isOpen}
			saveButtonClassName="!h-[44px]"
			secondSubmitButtonText={ts("discard")}
			submitButtonText={ts("saveAndClose")}
			subtitle={ts("description")}
			title={ts("title")}
		>
			<div />
		</Modal>
	);
}
